interface ArticleContent {
  body: string;
  author: string;
  source: string;
}

export const articleContents: Record<string, ArticleContent> = {
  'top-star-scandal-2026': {
    author: '吃瓜前线',
    source: '独家爆料',
    body: `<p>近日，一则关于某顶流男星的爆料在网络上引发轩然大波。据知情人士透露，该男星于6月25日凌晨在某五星级酒店密会一名神秘女子，两人在酒店共处超过8小时。</p>
    <p>根据曝光的酒店监控画面显示，该男星于凌晨1点23分独自进入酒店大堂，随后一名戴着口罩和墨镜的女子紧随其后进入。两人一前一后进入同一楼层的房间，期间该男星多次出入房间，最后一次离开是在次日早上9点45分。</p>
    <h3>网友扒出女方身份</h3>
    <p>消息传出后，网友们迅速展开"侦查"。有网友通过对比女方身形、着装和配饰，指出该神秘女子疑似某知名网红"小甜心Baby"。两人此前曾在社交平台上有过互动，男方曾多次点赞女方的动态。</p>
    <p>更有细心网友发现，该网红在6月25日当天发布了一条动态："昨晚失眠了，今天要好好补觉"，IP地址恰好显示在该酒店所在城市，进一步坐实了网友的猜测。</p>
    <h3>粉丝反应两极化</h3>
    <p>该男星一直以"单身贵族"人设示人，此次爆料让大量粉丝感到失望。有粉丝在超话中表示："如果是真的，感觉被欺骗了这么多年"；也有理智粉认为："就算是真的也没什么，明星也是人，有正常感情需求"。</p>
    <p>但更多的吃瓜群众则抱着看热闹的心态，评论区充满了"坐等实锤""这个瓜我先吃了""今年的塌房KPI又完成了"等调侃。</p>
    <h3>工作室尚未回应</h3>
    <p>截至发稿时，该男星的工作室尚未对此事作出任何回应。其经纪人电话一直处于关机状态。有业内人士分析，如果此事属实，该男星代言的多个品牌可能会受到影响，其中不乏国际一线奢侈品牌。</p>
    <p>本网将持续关注此事进展，第一时间为您带来最新消息。</p>`,
  },
  'influencer-live-broadcast-scandal': {
    author: '深夜瓜农',
    source: '直播间实录',
    body: `<p>拥有超过1200万粉丝的知名网红"小野猫"在昨晚的直播中遭遇了史诗级翻车事件。在直播过程中，她不慎将手机屏幕投屏到了直播画面中，微信聊天列表被数十万在线观众看得一清二楚。</p>
    <p>根据网友截图显示，其微信聊天列表中至少有6个暧昧对象，其中不乏圈内知名人士。有网友通过头像和备注信息，迅速锁定了多名当事人的身份。</p>
    <h3>聊天内容尺度惊人</h3>
    <p>虽然聊天记录只暴露了几秒钟，但眼尖的网友已经截图并逐帧分析。从可见的内容来看，聊天涉及到约会安排、礼物索取以及一些大尺度对话。其中与某位圈内男星的对话尤其引人注目，内容暗示两人关系非同一般。</p>
    <p>"我当时看到直接愣住了，这是能播的吗？"一位观看了直播的网友在社交平台发帖，迅速获得了超过50万的点赞。</p>
    <h3>紧急下播引发更多猜测</h3>
    <p>意识到"翻车"后，该网红在3秒内匆忙关闭了直播。随后她发了一条简短的动态："手滑了，大家不要乱传"，但这条动态很快被删除。这种反应反而激发了网友更大的好奇心，相关话题迅速冲上热搜榜首。</p>
    <h3>品牌方集体沉默</h3>
    <p>该网红目前代言的6个品牌中，已有3个品牌悄悄下架了与她相关的宣传内容。业内人士表示，如果事态继续发酵，她可能面临巨额违约金赔偿。</p>`,
  },
  'actress-secret-relationship': {
    author: '圈内老鬼',
    source: '多方核实',
    body: `<p>娱乐圈又一重磅炸弹！一位自称是某当红女星前助理的网友，在社交平台发布长篇爆料，详细描述了该女星秘密结婚生子的全过程，引发全网震动。</p>
    <p>该爆料者称自己从2019年至2023年期间担任该女星的私人助理，对其私生活了如指掌。据其描述，该女星在2021年就已秘密领证结婚，丈夫是一位圈外商人。2022年底，她在国外一家私立医院产下一名男婴。</p>
    <h3>晒出内部工作群截图</h3>
    <p>为了证明自己所言非虚，该爆料者晒出了多张据称是内部工作群的聊天截图。截图中涉及的事项包括："帮姐订去LA的机票，要商务舱""联系XX私立医院，预约下周的产检"等具体信息。</p>
    <p>虽然截图中的头像和姓名被打了码，但通过对话语境和一些细节信息，网友基本确认了截图中的"姐"就是该女星。</p>
    <h3>隐婚原因分析</h3>
    <p>业内人士分析，该女星之所以选择隐婚，主要有两方面原因：一是其经纪合约中有"合约期内保持单身形象"的条款；二是她目前正处于事业上升期，公开婚姻状况可能会影响粉丝基础和商业价值。</p>
    <p>"但她隐瞒得太深了，连合作多年的搭档都不知道她已婚。"一位与该女星合作过的导演在接受采访时表示震惊。</p>
    <h3>粉丝态度分化</h3>
    <p>消息传出后，该女星的粉丝群体出现了明显的分裂。一部分铁粉选择支持偶像："姐姐幸福就好，结不结婚是她的自由"；另一部分则感到被欺骗："如果你一开始就说清楚，我们也会支持，但欺骗是最伤人的"。</p>`,
  },
  'variety-show-controversy': {
    author: '现场目击者',
    source: '独家消息',
    body: `<p>某热门选秀综艺节目录制现场爆发了激烈的冲突！两位资深导师因为在选手评分上意见不合，在录制现场当众爆发争吵，场面一度失控。</p>
    <p>据现场观众描述，冲突的起因是关于一位选手的去留问题。导师A认为该选手表现优异应该晋级，而导师B则指出该选手存在严重的专业基础问题。两人各执一词，争论逐渐升级。</p>
    <h3>摔麦离场，场面尴尬</h3>
    <p>"当时导师B突然站起来，指着导师A说'你这样是在害他'，然后直接把话筒摔在了地上，转身就走。"一位不愿透露姓名的现场观众还原了当时的情景。</p>
    <p>导师B的突然离场让整个录制现场陷入混乱。节目组紧急叫停录制，工作人员花了近一个小时才说服两位导师回到现场继续录制。</p>
    <h3>节目组内部声音</h3>
    <p>有节目组内部人员透露，两位导师之间的矛盾由来已久。"他们俩在私下里就不怎么说话，这次只是积怨已久的一个爆发点。"该人员还透露，节目组正在考虑是否需要在后期剪辑中删掉这段冲突内容。</p>
    <h3>播出命运成谜</h3>
    <p>目前该期节目的播出时间尚未确定。有消息称节目组正在评估这件事对节目口碑的影响，不排除重新录制该环节的可能性。网友们则纷纷表示："千万别剪，这才是我们想看的！""没有冲突哪来的收视率？"</p>`,
  },
  'boy-band-member-dating': {
    author: '狗仔阿强',
    source: '独家蹲守',
    body: `<p>经过长达两周的蹲守，我们终于拍到了某当红男团成员深夜约会女粉丝的实锤画面。这也是该成员自出道以来首次被拍到与异性深夜独处的画面。</p>
    <p>根据监控画面显示，6月27日凌晨2点15分左右，该男团成员戴着口罩和鸭舌帽，与一名年轻女子一同步入其位于市中心的高档公寓。两人在电梯间等候时举止亲密，女子多次主动挽住男方手臂。</p>
    <h3>女方身份曝光</h3>
    <p>经多方核实，该女子确认为该男团成员的一名"站姐"（资深粉丝），长期负责该成员的应援和拍摄工作。消息传出后，该成员的粉丝圈彻底炸锅。</p>
    <p>"我们花钱养他，他拿钱养嫂子？"一位脱粉粉丝在社交平台上的发言获得了大量点赞。不少粉丝表示心碎，有人甚至公开烧毁了大量周边产品。</p>
    <h3>经纪公司紧急公关</h3>
    <p>事件发酵后，该男团所属经纪公司火速发布声明，称"两人只是普通朋友关系，当天是一起讨论工作事宜"，并表示将追究偷拍者的法律责任。</p>
    <p>然而，网友们并不买账。"凌晨两点讨论工作？这借口也太敷衍了吧""希望哥哥能够诚实面对，不要欺骗粉丝了"等评论充斥了各个社交平台。</p>`,
  },
  'beauty-blogger-fake-products': {
    author: '消费侦探',
    source: '调查报道',
    body: `<p>拥有800万粉丝的美妆博主"甜心教主"再次陷入假货风波！多位粉丝将其直播间购买的美妆产品送去专业机构鉴定，结果令人震惊——全部为假冒产品。</p>
    <p>据悉，该博主在近期的多场直播中大力推荐了一款"进口高端精华液"，售价299元，号称"专柜正品""假一赔十"。然而，当粉丝收到产品后发现包装粗糙、味道刺鼻，与正品差异明显。</p>
    <h3>鉴定结果令人震惊</h3>
    <p>一位购买了该产品的粉丝将产品送到第三方检测机构进行鉴定。检测报告显示，该产品不仅不是所谓的"进口高端精华液"，其成分中甚至含有超标的重金属物质，长期使用可能对皮肤造成严重伤害。</p>
    <p>"我用了之后脸上起了好多红疹，去医院看说是过敏。"另一位受害者在社交平台上晒出了就医记录，引发更多消费者的声援。</p>
    <h3>品牌方发布律师函</h3>
    <p>被冒用的品牌方在获悉此事后，迅速发布了律师函，表示将追究该博主的法律责任。品牌方在声明中强调："从未授权该主播销售本公司任何产品，其直播间销售的所谓本公司产品均系假冒伪劣。"</p>
    <h3>面临天价赔偿</h3>
    <p>据不完全统计，该博主通过直播间销售该假冒产品的总金额已超过500万元。如果按照"假一赔十"的承诺，她需要向消费者赔付超过5000万元。目前已有超过200名消费者联合维权，案件正在进一步处理中。</p>`,
  },
  'actor-tax-evasion': {
    author: '财金观察',
    source: '权威信源',
    body: `<p>继多位明星因税务问题"塌房"后，又一位知名演员被曝涉嫌偷税漏税。据权威消息，税务部门已正式约谈该演员，要求其就近年来的税务申报问题作出解释。</p>
    <p>初步调查显示，该演员近三年申报的个人收入与实际收入严重不符。通过"阴阳合同"、拆分收入、虚列成本等多种手段，涉嫌偷逃税款高达数千万元。</p>
    <h3>手法"专业"令人咋舌</h3>
    <p>据税务人员透露，该演员的避税手段极为"专业"：将个人片酬包装成工作室收入，利用不同地区税收优惠政策进行"税收筹划"，甚至通过境外账户转移资金。这些操作都是由一支专业的财务团队精心设计。</p>
    <p>"从表面上看，他的每一笔申报都'合法合规'，但实质上就是钻法律空子。"一位参与调查的税务人员表示。</p>
    <h3>多部待播作品受影响</h3>
    <p>该演员目前有3部电视剧和2部电影待播，总投资额超过10亿元。如果税务问题坐实，这些作品很可能面临无法播出的风险，将给投资方带来巨额损失。</p>
    <p>目前已有两家视频平台紧急叫停了与该演员相关的项目，业内普遍认为这是在提前"割席"。</p>
    <h3>工作室发文"辟谣"</h3>
    <p>面对愈演愈烈的传闻，该演员工作室发布声明称"已依法纳税，不存在偷税漏税行为"，并表示将对造谣者追究法律责任。然而，网友们普遍持怀疑态度："上一个这么说的现在已经进去了"。</p>`,
  },
  'streamer-gambling-scandal': {
    author: '网警观察',
    source: '警方通报',
    body: `<p>游戏直播圈炸了！某知名游戏主播被曝在其直播间内变相组织网络赌博活动，通过直播间的"抽奖"功能吸引粉丝参与赌博，涉案金额惊人。</p>
    <p>据调查，该主播在直播游戏过程中，频繁插入"幸运大转盘"环节。观众需要先送出价值不等的虚拟礼物才能获得"抽奖资格"，奖品包括现金、电子产品甚至豪车，实质上是变相的网络赌博。</p>
    <h3>抽奖背后的"生意经"</h3>
    <p>知情人士透露，该主播的"抽奖"规则经过了精心设计：参与门槛从几十元到上千元不等，中奖概率极低但对观众极具诱惑力。仅过去半年时间，该主播通过此方式获得的虚拟礼物价值就超过2000万元。</p>
    <p>"这本质上就是一种赌博行为，只是换了一个看起来合法的外壳。"一位法律专家在接受采访时表示，这种行为已经触犯了相关法律法规。</p>
    <h3>警方已介入调查</h3>
    <p>据接近警方的消息人士透露，网警部门已经注意到该主播的行为并展开调查。如果罪名成立，该主播可能面临刑事处罚，其背后的直播平台也可能承担相应的监管责任。</p>
    <h3>直播平台紧急回应</h3>
    <p>事件曝光后，该主播所在的直播平台紧急发布声明，称已暂停该主播的直播权限，并将配合相关部门进行调查。同时，平台表示将全面排查所有直播间，杜绝类似行为。</p>`,
  },
  'singer-plagiarism': {
    author: '音乐侦探',
    source: '专业对比',
    body: `<p>新晋歌手"小柠檬"最近发布的新歌《星光》被多名音乐博主指出抄袭国外某歌手的作品。经过专业对比分析，两首歌的副歌部分旋律相似度超过80%。</p>
    <p>音乐博主"耳朵很尖"制作了一段详细的对比视频，将两首歌的副歌部分逐小节进行比对。视频中，两段旋律几乎可以完美重叠，差异微乎其微。</p>
    <h3>专业分析实锤</h3>
    <p>某音乐学院教授在接受采访时表示："从专业角度分析，两首歌在和弦走向、旋律线条以及节奏型上高度一致。这种程度的相似性，用'巧合'来解释是很难令人信服的。"</p>
    <p>不仅如此，网友还发现《星光》的编曲风格和配器方式也与被抄袭歌曲几乎一致，进一步加深了抄袭的嫌疑。</p>
    <h3>原创作者回应</h3>
    <p>被抄袭歌曲的原作者通过社交媒体发了一条意味深长的动态："Imitation is the sincerest form of flattery（模仿是最真诚的奉承）"，虽然没有直接点名，但发布时间恰好与抄袭争议爆发的时间吻合。</p>
    <p>据消息人士透露，原创作者团队已经在联系律师，准备通过法律途径维权。</p>
    <h3>歌手方的苍白解释</h3>
    <p>面对如潮的质疑，歌手团队发布声明称"创作灵感来源于生活，如有雷同纯属巧合"。这一敷衍的回应激怒了更多网友："这也叫巧合？那彩票中奖也是巧合了？""建议直接退圈吧"。</p>`,
  },
  'influencer-couple-breakup': {
    author: '情感观察员',
    source: '当事人发声',
    body: `<p>曾被誉为"网红界模范情侣"的"阿杰与小月"正式官宣分手！女方随后发布长文控诉男方在恋爱期间多次出轨，引发全网哗然。</p>
    <p>小月在社交平台发布了一篇超过2000字的长文，详细描述了她在恋爱期间发现男方出轨的过程。"我以为你是那个对的人，结果你是对所有女生都好的人。"这句话迅速成为热门语录。</p>
    <h3>多名受害者联合发声</h3>
    <p>在小月发布长文后，又有三名自称曾与阿杰有过感情纠葛的女性站出来发声。她们建立了一个维权群，分享各自的经历，发现男方的"套路"惊人地一致：先是对女方极尽温柔，然后以"工作忙""需要空间"等理由冷暴力，最后被发现他同时在和多人交往。</p>
    <p>"我们不是想毁了他，我们只是不想让更多人被骗。"维权群的发起人这样表示。</p>
    <h3>男方沉默引发更多猜测</h3>
    <p>截至目前，阿杰未对此事作出任何回应。他的社交账号最新动态仍停留在三天前的一条广告推广。评论区已彻底沦陷，点赞最高的评论是："出来走两步？"</p>
    <p>有消息称阿杰正在紧急联系公关团队，试图将此事的影响降到最低。但多位公关人士表示，事态发展到这个地步，任何公关手段都难以挽回。</p>
    <h3>品牌方解约潮</h3>
    <p>受此事件影响，阿杰代言的3个品牌已宣布与其解约。据估算，他因此损失的收入至少在数百万元以上。而小月则因"勇气"获得了大量新粉丝，不少品牌向她伸出了橄榄枝。</p>`,
  },
};

export function getArticleContent(slug: string): ArticleContent | null {
  return articleContents[slug] || null;
}

export function getArticleSlugs(): string[] {
  return Object.keys(articleContents);
}